export const videos = [
  {
    id: "niliu-ershang",
    title: "逆流而上",
    type: "电影",
    region: "大陆",
    year: 2025,
    rating: 8.9,
    status: "正片已上线",
    tags: ["剧情", "运动", "励志"],
    director: "陈屿",
    cast: ["林海舟", "苏晚晴", "周牧"],
    summary: "一名遭遇职业生涯重创的游泳运动员，在旧友与家人的陪伴下重返赛场。他用一次次逆流而上的出发，回答了什么才是真正的胜负。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20lone%20swimmer%20emerging%20from%20dark%20still%20water%20at%20dawn%2C%20warm%20amber%20light%20rim%2C%20moody%20charcoal%20tones%2C%20dramatic%20side%20lighting%2C%20no%20text%2C%20editorial%20quality%2C%20high%20detail&width=600&height=900&seq=mg-cover-01&orientation=portrait",
    episodeCount: 1,
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=wide%20cinematic%20atmospheric%20banner%20of%20a%20lone%20swimmer%20emerging%20from%20dark%20still%20water%20at%20dawn%20with%20warm%20amber%20rim%20light%20and%20drifting%20mist%2C%20moody%20charcoal%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=mg-banner-01&orientation=landscape",
    tagline: "每一次出发，都是与自己的和解",
  },
  {
    id: "xingji-xinshi",
    title: "星际信使",
    type: "电影",
    region: "欧美",
    year: 2026,
    rating: 9.1,
    status: "正片已上线",
    tags: ["科幻", "冒险", "悬疑"],
    director: "Evan Cole",
    cast: ["Marcus Reed", "Nora Vale", "Leo Ito"],
    summary: "深空探测船收到一段来自未知星域的重复信号。当人类第一次尝试回应，等待他们的却是关于文明存续的艰难抉择。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20an%20astronaut%20facing%20a%20giant%20faint%20signal%20orb%20in%20deep%20space%2C%20warm%20orange%20glow%20against%20dark%20void%2C%20dramatic%20lighting%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-02&orientation=portrait",
    episodeCount: 1,
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=wide%20cinematic%20atmospheric%20banner%20of%20a%20lone%20astronaut%20facing%20a%20vast%20glowing%20orange%20signal%20orb%20in%20deep%20space%20with%20scattered%20stars%2C%20dark%20void%20with%20warm%20amber%20glow%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=mg-banner-02&orientation=landscape",
    tagline: "宇宙深处，谁在等待回应",
  },
  {
    id: "changan-huifang",
    title: "长安回望",
    type: "电影",
    region: "大陆",
    year: 2024,
    rating: 8.6,
    status: "正片已上线",
    tags: ["古装", "历史", "剧情"],
    director: "顾长风",
    cast: ["沈墨白", "温知喻", "贺兰山"],
    summary: "一位被贬的史官在归乡途中重走长安旧路，用一卷未完的笔记，记录了盛世落幕前最后的烟火与人心。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20historical%20chinese%20movie%20poster%20of%20a%20scholar%20in%20traditional%20robe%20gazing%20at%20an%20ancient%20city%20at%20dusk%2C%20warm%20amber%20lantern%20glow%2C%20muted%20earth%20tones%2C%20dramatic%20lighting%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-03&orientation=portrait",
    episodeCount: 1,
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=wide%20cinematic%20atmospheric%20banner%20of%20an%20ancient%20chinese%20city%20skyline%20at%20dusk%20with%20warm%20amber%20lantern%20glow%20and%20floating%20mist%2C%20muted%20earth%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=mg-banner-03&orientation=landscape",
    tagline: "盛世落幕前的最后一卷笔记",
  },
  {
    id: "wusheng-gaobai",
    title: "无声告白",
    type: "电影",
    region: "港台",
    year: 2025,
    rating: 8.4,
    status: "正片已上线",
    tags: ["悬疑", "犯罪", "剧情"],
    director: "何嘉树",
    cast: ["郑允澄", "林以凡", "许南乔"],
    summary: "一桩看似普通的失踪案，牵出横跨十年的沉默真相。当所有人都选择闭嘴，唯一愿意开口的人反而成了嫌疑人。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20suspense%20movie%20poster%20of%20a%20silhouette%20figure%20standing%20in%20a%20narrow%20rainy%20alley%20under%20a%20single%20warm%20street%20lamp%2C%20dark%20charcoal%20tones%2C%20dramatic%20lighting%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-04&orientation=portrait",
    episodeCount: 1,
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=wide%20cinematic%20atmospheric%20banner%20of%20a%20silhouette%20figure%20in%20a%20narrow%20rainy%20alley%20under%20a%20single%20warm%20amber%20street%20lamp%20with%20reflections%2C%20dark%20charcoal%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=mg-banner-04&orientation=landscape",
    tagline: "当所有人都沉默",
  },
  {
    id: "shanhai-zhiyue",
    title: "山海之约",
    type: "电影",
    region: "大陆",
    year: 2025,
    rating: 8.2,
    status: "正片已上线",
    tags: ["奇幻", "爱情", "冒险"],
    director: "白鹿原",
    cast: ["凌霜", "江砚", "顾星河"],
    summary: "传说中掌管山海的门扉每百年开启一次。一个不愿离开人间的守门人，与一个执意跨越山海的旅人，在此刻相遇。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20movie%20poster%20of%20two%20figures%20on%20a%20cliff%20overlooking%20misty%20mountains%20and%20sea%2C%20warm%20golden%20sunset%20glow%2C%20muted%20teal%20and%20amber%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-05&orientation=portrait",
    episodeCount: 1,
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=wide%20cinematic%20atmospheric%20banner%20of%20misty%20mountains%20meeting%20a%20calm%20sea%20under%20a%20warm%20golden%20sunset%2C%20muted%20teal%20and%20amber%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=mg-banner-05&orientation=landscape",
    tagline: "跨越山海的相遇",
  },
  {
    id: "gudao-shouwang",
    title: "孤岛守望",
    type: "电影",
    region: "日韩",
    year: 2024,
    rating: 7.9,
    status: "正片已上线",
    tags: ["惊悚", "悬疑", "剧情"],
    director: "佐藤凉",
    cast: ["高桥彻", "美咲凛", "田中圭一"],
    summary: "一名灯塔看守人独自驻守孤岛，暴风雨夜他发现日志上多出了一些并非自己写下的记录。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20thriller%20movie%20poster%20of%20a%20lonely%20lighthouse%20on%20a%20rocky%20island%20during%20a%20storm%2C%20warm%20beacon%20light%20cutting%20dark%20clouds%2C%20moody%20charcoal%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-06&orientation=portrait",
    episodeCount: 1,
    featured: false,
    tagline: "暴风雨夜，多出的记录",
  },
  {
    id: "chengshi-zhiguang",
    title: "城市之光",
    type: "电视剧",
    region: "大陆",
    year: 2025,
    rating: 8.7,
    status: "更新至 24 集",
    tags: ["都市", "职场", "剧情"],
    director: "宋知远",
    cast: ["顾清和", "程雨桐", "陆时昭"],
    summary: "一群怀揣理想的城市建设者，在繁华与喧嚣之间，为普通人点亮了一盏又一盏灯。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20of%20a%20young%20professional%20standing%20before%20a%20city%20skyline%20at%20blue%20hour%2C%20warm%20window%20lights%2C%20charcoal%20and%20amber%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-07&orientation=portrait",
    episodeCount: 24,
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=wide%20cinematic%20atmospheric%20banner%20of%20a%20glowing%20city%20skyline%20at%20blue%20hour%20with%20countless%20warm%20amber%20window%20lights%2C%20charcoal%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=mg-banner-06&orientation=landscape",
    tagline: "为普通人点亮一盏灯",
  },
  {
    id: "jinyiwei-chuanshuo",
    title: "锦衣卫传说",
    type: "电视剧",
    region: "大陆",
    year: 2024,
    rating: 8.3,
    status: "全 40 集",
    tags: ["古装", "武侠", "悬疑"],
    director: "岳沉舟",
    cast: ["萧景玄", "苏蓦然", "裴岩"],
    summary: "一柄绣春刀，一段旧江湖。年轻的锦衣卫在庙堂与江湖的夹缝中，追寻一桩牵连甚广的旧案。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wuxia%20drama%20poster%20of%20a%20warrior%20in%20dark%20traditional%20armor%20holding%20a%20blade%2C%20warm%20torchlight%20against%20dark%20background%2C%20muted%20earth%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-08&orientation=portrait",
    episodeCount: 40,
    featured: false,
    tagline: "一柄绣春刀，一段旧江湖",
  },
  {
    id: "sanshi-buhuo",
    title: "三十不惑",
    type: "电视剧",
    region: "大陆",
    year: 2025,
    rating: 8.5,
    status: "更新至 18 集",
    tags: ["都市", "家庭", "剧情"],
    director: "林知秋",
    cast: ["沈知夏", "周正", "杨蔓"],
    summary: "三位三十岁的好友，在事业、家庭与自我之间反复摇摆，最终学会与不完美的人生握手言和。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20of%20three%20friends%20walking%20a%20city%20street%20at%20warm%20sunset%2C%20soft%20amber%20backlight%2C%20muted%20neutral%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-09&orientation=portrait",
    episodeCount: 18,
    featured: false,
    tagline: "与不完美的人生和解",
  },
  {
    id: "xinghuo-liaoyuan",
    title: "星火燎原",
    type: "电视剧",
    region: "大陆",
    year: 2024,
    rating: 8.8,
    status: "全 32 集",
    tags: ["战争", "历史", "剧情"],
    director: "高远山",
    cast: ["秦川", "孟繁星", "铁林"],
    summary: "战火纷飞的年代里，一群普通人用信念与热血，把微弱星火汇聚成燎原之势。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20war%20drama%20poster%20of%20a%20group%20of%20figures%20walking%20through%20a%20dusty%20field%20at%20sunset%2C%20warm%20smoky%20amber%20light%2C%20muted%20earthy%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-10&orientation=portrait",
    episodeCount: 32,
    featured: false,
    tagline: "微弱星火，终成燎原",
  },
  {
    id: "anxiang-zhuixiong",
    title: "暗巷追凶",
    type: "电视剧",
    region: "港台",
    year: 2025,
    rating: 8.6,
    status: "更新至 20 集",
    tags: ["刑侦", "悬疑", "犯罪"],
    director: "陈立铭",
    cast: ["麦子豪", "何静仪", "关子睿"],
    summary: "新城接连发生离奇案件，一名固执的老刑警与一名新锐法医联手，在蛛丝马迹中追寻真相。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%20of%20a%20detective%20inspecting%20a%20dim%20crime%20scene%20alley%2C%20warm%20flashlight%20beam%2C%20charcoal%20and%20amber%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-11&orientation=portrait",
    episodeCount: 20,
    featured: false,
    tagline: "蛛丝马迹，真相必现",
  },
  {
    id: "shiguang-lide-women",
    title: "时光里的我们",
    type: "电视剧",
    region: "大陆",
    year: 2024,
    rating: 8.1,
    status: "全 24 集",
    tags: ["青春", "爱情", "剧情"],
    director: "苏念安",
    cast: ["夏桉", "顾寒", "林知夏"],
    summary: "从校服到婚纱，从分别到重逢。两个在时光里走散的人，用十年时间完成了一场漫长的告白。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20youth%20romance%20drama%20poster%20of%20two%20young%20people%20on%20a%20school%20rooftop%20at%20golden%20hour%2C%20soft%20warm%20backlight%2C%20muted%20neutral%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-12&orientation=portrait",
    episodeCount: 24,
    featured: false,
    tagline: "一场漫长的告白",
  },
  {
    id: "shenhai-daima",
    title: "深海代码",
    type: "电视剧",
    region: "大陆",
    year: 2026,
    rating: 8.9,
    status: "更新至 12 集",
    tags: ["科幻", "悬疑", "剧情"],
    director: "方舟",
    cast: ["顾知微", "沈墨", "白泽宇"],
    summary: "深海研究站的人工智能突然失控，工程师们发现，真正被写进代码里的，是一段人类不敢面对的秘密。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20drama%20poster%20of%20an%20underwater%20research%20station%20with%20glowing%20warm%20amber%20lights%20in%20dark%20ocean%2C%20moody%20teal%20and%20charcoal%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-13&orientation=portrait",
    episodeCount: 12,
    featured: false,
    tagline: "被写进代码里的秘密",
  },
  {
    id: "yunshang-yiguan",
    title: "云上医馆",
    type: "电视剧",
    region: "大陆",
    year: 2024,
    rating: 8.0,
    status: "全 36 集",
    tags: ["古装", "医疗", "剧情"],
    director: "云间客",
    cast: ["叶清欢", "陆行舟", "温予安"],
    summary: "云上山间的一间小医馆，往来皆是江湖客。女主凭一手医术，治愈他人，也治愈自己。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20medical%20drama%20poster%20of%20a%20herb%20apothecary%20in%20misty%20mountains%2C%20warm%20lantern%20glow%2C%20muted%20earth%20green%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-14&orientation=portrait",
    episodeCount: 36,
    featured: false,
    tagline: "治愈他人，也治愈自己",
  },
  {
    id: "xiangwang-shangu",
    title: "向往的山谷",
    type: "综艺",
    region: "大陆",
    year: 2025,
    rating: 8.8,
    status: "更新至 8 期",
    tags: ["真人秀", "生活", "治愈"],
    director: "李知白",
    cast: ["何一鸣", "彭越", "张子珊"],
    summary: "六位嘉宾回到山谷里的小院，种地、做饭、聊天，在慢下来的时光里找回生活本来的样子。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20lifestyle%20variety%20show%20poster%20of%20a%20cozy%20wooden%20courtyard%20in%20a%20green%20valley%20at%20golden%20hour%2C%20warm%20amber%20sunlight%2C%20muted%20green%20and%20earth%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-15&orientation=portrait",
    episodeCount: 8,
    featured: true,
    banner: "https://readdy.ai/api/search-image?query=wide%20cinematic%20atmospheric%20banner%20of%20a%20cozy%20wooden%20courtyard%20in%20a%20green%20valley%20at%20golden%20hour%20with%20warm%20amber%20sunlight%20and%20soft%20mist%2C%20muted%20green%20and%20earth%20tones%2C%20no%20text%2C%20high%20detail%20editorial%20quality&width=1600&height=900&seq=mg-banner-07&orientation=landscape",
    tagline: "慢下来，找回生活",
  },
  {
    id: "juxing-dazuozhan",
    title: "巨星大作战",
    type: "综艺",
    region: "大陆",
    year: 2025,
    rating: 8.4,
    status: "更新至 10 期",
    tags: ["音乐", "竞技", "真人秀"],
    director: "周律",
    cast: ["林漾", "高天", "苏墨", "韩雪"],
    summary: "跨代际歌手同台竞演，用一场场改编舞台，重新点燃经典与潮流的碰撞。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20music%20competition%20variety%20poster%20of%20a%20singer%20on%20stage%20under%20warm%20amber%20spotlights%2C%20dark%20audience%20background%2C%20muted%20teal%20and%20gold%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-16&orientation=portrait",
    episodeCount: 10,
    featured: false,
    tagline: "经典与潮流的碰撞",
  },
  {
    id: "jizhi-shenghuojia",
    title: "机智的生活家",
    type: "综艺",
    region: "大陆",
    year: 2024,
    rating: 8.1,
    status: "全 12 期",
    tags: ["生活", "真人秀", "治愈"],
    director: "邱野",
    cast: ["马思远", "黄淇", "许安然"],
    summary: "嘉宾用有限的预算，把平凡的日子过出仪式感，分享那些让生活变好的小心思。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20lifestyle%20variety%20poster%20of%20a%20bright%20cozy%20kitchen%20with%20warm%20morning%20sunlight%20and%20plants%2C%20muted%20cream%20and%20amber%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-17&orientation=portrait",
    episodeCount: 12,
    featured: false,
    tagline: "平凡日子里的仪式感",
  },
  {
    id: "tuokou-erchu",
    title: "脱口而出",
    type: "综艺",
    region: "大陆",
    year: 2025,
    rating: 8.9,
    status: "更新至 9 期",
    tags: ["脱口秀", "喜剧", "语言"],
    director: "贾哲",
    cast: ["程一诺", "老周", "方南", "林小满"],
    summary: "一群脱口秀演员把生活的褶皱摊开，用笑声替你说出那些想说又不敢说的话。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20standup%20comedy%20variety%20poster%20of%20a%20performer%20with%20a%20microphone%20on%20a%20dark%20stage%20with%20warm%20amber%20spotlight%2C%20muted%20charcoal%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-18&orientation=portrait",
    episodeCount: 9,
    featured: false,
    tagline: "替你说出不敢说的话",
  },
  {
    id: "benpao-xiongdituan",
    title: "奔跑吧兄弟团",
    type: "综艺",
    region: "大陆",
    year: 2026,
    rating: 8.2,
    status: "更新至 6 期",
    tags: ["竞技", "真人秀", "喜剧"],
    director: "陈野",
    cast: ["邓小超", "雷子", "朱迪", "白鹿"],
    summary: "兄弟团每期奔赴一座城市，用一场场爆笑又热血的挑战，把当地的风土人情玩出花样。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20outdoor%20game%20variety%20poster%20of%20a%20team%20running%20through%20a%20city%20street%20with%20warm%20sunset%20light%2C%20muted%20amber%20and%20charcoal%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-19&orientation=portrait",
    episodeCount: 6,
    featured: false,
    tagline: "把城市玩出花样",
  },
  {
    id: "meishi-xingqiu",
    title: "美食星球",
    type: "综艺",
    region: "大陆",
    year: 2024,
    rating: 8.6,
    status: "全 12 期",
    tags: ["美食", "纪实", "生活"],
    director: "汪知味",
    cast: ["沈大厨", "蔡晓", "周味"],
    summary: "从街头小吃到家常灶台，节目走访各地，用一顿饭的时间，讲述一座城与人之间的故事。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20food%20documentary%20variety%20poster%20of%20steaming%20dishes%20on%20a%20rustic%20wooden%20table%20warm%20lighting%2C%20muted%20amber%20and%20earth%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-20&orientation=portrait",
    episodeCount: 12,
    featured: false,
    tagline: "用一顿饭，讲一座城",
  },
  {
    id: "yifenzhong-zhexue",
    title: "一分钟哲学",
    type: "短视频",
    region: "大陆",
    year: 2025,
    rating: 8.3,
    status: "已更新 120 条",
    tags: ["知识", "短片", "人文"],
    director: "芒果短剧工作室",
    cast: ["主讲：季老师"],
    summary: "用一分钟，把那些看似高深的道理讲成生活里的碎片。适合通勤、睡前的轻量思考。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20minimal%20short%20video%20poster%20of%20a%20single%20glowing%20lightbulb%20on%20a%20dark%20warm%20amber%20background%2C%20muted%20charcoal%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-21&orientation=portrait",
    episodeCount: 120,
    featured: false,
    tagline: "一分钟，一点思考",
  },
  {
    id: "chengshi-jiepai-riji",
    title: "城市街拍日记",
    type: "短视频",
    region: "大陆",
    year: 2025,
    rating: 8.0,
    status: "已更新 86 条",
    tags: ["纪实", "短片", "生活"],
    director: "芒果短剧工作室",
    cast: ["摄影：小舟"],
    summary: "用镜头记录城市里擦肩而过的陌生人，那些被忽略的表情与瞬间，都值得被留下。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20street%20photography%20short%20video%20poster%20of%20a%20person%20walking%20a%20city%20street%20with%20warm%20neon%20reflections%20at%20dusk%2C%20muted%20amber%20and%20charcoal%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-22&orientation=portrait",
    episodeCount: 86,
    featured: false,
    tagline: "被忽略的瞬间",
  },
  {
    id: "jujia-jianshencao",
    title: "居家健身操",
    type: "短视频",
    region: "大陆",
    year: 2024,
    rating: 7.8,
    status: "已更新 64 条",
    tags: ["运动", "短片", "健康"],
    director: "芒果短剧工作室",
    cast: ["教练：阿凯"],
    summary: "每天十分钟，用最简单不扰邻的动作，把运动变成一种轻松的日常习惯。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fitness%20short%20video%20poster%20of%20a%20person%20stretching%20in%20a%20cozy%20sunlit%20living%20room%2C%20warm%20amber%20morning%20light%2C%20muted%20neutral%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-23&orientation=portrait",
    episodeCount: 64,
    featured: false,
    tagline: "十分钟，轻松动起来",
  },
  {
    id: "mengchong-guanchashi",
    title: "萌宠观察室",
    type: "短视频",
    region: "大陆",
    year: 2025,
    rating: 8.1,
    status: "已更新 150 条",
    tags: ["萌宠", "短片", "治愈"],
    director: "芒果短剧工作室",
    cast: ["出镜：汤圆 / 布丁"],
    summary: "每天一条，记录两只胖猫的作妖日常。看完只想说一句：好想rua一口。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20cute%20pet%20short%20video%20poster%20of%20two%20fluffy%20cats%20lounging%20on%20a%20warm%20sunlit%20window%20sill%2C%20soft%20amber%20light%2C%20muted%20cream%20tones%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=mg-cover-24&orientation=portrait",
    episodeCount: 150,
    featured: false,
    tagline: "每天一只，治愈一整天",
  },
];